module.exports = [
  {
    "slug": "cems",
    "name": "Cems",
    "link": "https://www.cems.org/"
  },
  {
    "slug": "compostela-group",
    "name": "Compostela group",
    "link": "http://web.gcompostela.org/"
  },
  {
    "slug": "esn-international",
    "name": "Esn international",
    "link": "https://esn.org/"
  },
  {
    "slug": "qs",
    "name": "Qs",
    "link": "https://www.topuniversities.com/qs-world-university-rankings"
  },
  {
    "slug": "nova",
    "name": "Nova",
    "link": "https://www.unl.pt/en/"
  },
  {
    "slug": "studyportals",
    "name": "StudyPortals",
    "link": "https://studyportals.com/"
  },
  {
    "slug": "interns-go-pro",
    "name": "Interns go pro",
    "link": "http://www.internsgopro.com/en/home/"
  },
  {
    "slug": "elsa",
    "name": "Elsa",
    "link": "https://elsa.org/"
  },
  {
    "slug": "eyca",
    "name": "Eyca",
    "link": "https://www.eyca.org/"
  },
  {
    "slug": "aegee",
    "name": "Aegee",
    "link": "https://www.aegee.org/"
  },
  {
    "slug": "aiesec",
    "name": "Aiesec",
    "link": "https://aiesec.org/"
  },
  {
    "slug": "epsa",
    "name": "Epsa",
    "link": "https://www.epsa-online.org/"
  },
  {
    "slug": "universitat-politecnica-de-catalunya",
    "name": "Universitat Politècnica de Catalunya",
    "link": "https://www.upc.edu/ca"
  },
  {
    "slug": "university-of-granada",
    "name": "University of Granada",
    "link": "https://www.ugr.es/"
  },
  {
    "slug": "europe-language-jobs",
    "name": "Europe language jobs",
    "link": "https://www.europelanguagejobs.com/"
  },
  {
    "slug": "isic",
    "name": "Isic",
    "link": "https://www.isic.org/"
  },
  {
    "slug": "jade",
    "name": "Jade",
    "link": "https://juniorenterprises.eu/"
  },
  {
    "slug": "stud-and-globe",
    "name": "Stud and globe",
    "link": "https://studandglobe.com/fr/"
  },
  {
    "slug": "the-class-of-2020",
    "name": "The class of 2020",
    "link": "https://theclassof2020.org/"
  },
  {
    "slug": "bfsw",
    "name": "Bfsw",
    "link": "https://bundesverband-micro-living.de/"
  },
  {
    "slug": "student-job",
    "name": "Student job",
    "link": "https://www.studentjob.co.uk/info/international"
  },
  {
    "slug": "information-planet",
    "name": "Information Planet",
    "link": "https://www.informationplanet.pt"
  },
  {
    "slug": "university-box",
    "name": "University Box",
    "link": "https://www.universitybox.com/"
  },
  {
    "slug": "easy-future",
    "name": "Easy Future",
    "link": "https://www.easyfuture.pt/"
  },
  {
    "slug": "ied-istituto-europeo-di-design",
    "name": "IED Istituto Europeo di Design",
    "link": "https://www.ied.it/"
  },
  {
    "slug": "premium-education-consulting",
    "name": "Premium Education Consulting",
    "link": "https://www.education-consulting.ma/"
  },
  {
    "slug": "tauschwohnung",
    "name": "Tauschwohnung",
    "link": "https://www.tauschwohnung.com"
  },
  {
    "slug": "admitad",
    "name": "Admitad",
    "link": "https://www.admitad.com/"
  },
  {
    "slug": "expat-empire",
    "name": "Expat Empire",
    "link": "https://expatempire.com/"
  },
  {
    "slug": "birds-intercambio-cultural",
    "name": "Birds Intercâmbio Cultural",
    "link": "https://www.birdsintercambio.com.br/"
  },
  {
    "slug": "jooble",
    "name": "Jooble",
    "link": "https://jooble.org/"
  },
  {
    "slug": "eurosender",
    "name": "Eurosender",
    "link": "https://www.eurosender.com/"
  },
  {
    "slug": "europa.jobs",
    "name": "europa.jobs",
    "link": "https://en.europa.jobs/"
  },
  {
    "slug": "asap-portuguese-citizenship",
    "name": "ASAP Portuguese Citizenship",
    "link": "https://asapcidadaniaportuguesa.com/"
  },
  {
    "slug": "konsulting-global",
    "name": "Konsulting Global",
    "link": "https://www.konsulting-global.es/"
  },
  {
    "slug": "barcelona-academy-of-art",
    "name": "Barcelona Academy of Art",
    "link": "https://www.academyofartbarcelona.com"
  },
  {
    "slug": "thingstodoinamterdam.com",
    "name": "ThingstodoinAmterdam.com",
    "link": "https://thingstodoinamsterdam.com/"
  },
  {
    "slug": "studiesin",
    "name": "StudiesIn",
    "link": "https://studiesin.com/"
  },
  {
    "slug": "student-travel-tips",
    "name": "Student Travel Tips",
    "link": "https://studenttraveltips.co.uk/"
  },
  {
    "slug": "grades-up",
    "name": "Grades Up",
    "link": "https://apps.apple.com/pt/app/grades-up/id1670189221"
  },
  {
    "slug": "ailu",
    "name": "Ailu",
    "link": "https://ailu.com.br/"
  },
  {
    "slug": "erastay",
    "name": "Erastay",
    "link": "https://erastay.com/"
  },
  {
    "slug": "the-campus-advisor",
    "name": "The Campus Advisor",
    "link": "https://www.thecampusadvisor.com/"
  },
  {
    "slug": "barcelona-code-school",
    "name": "Barcelona Code School",
    "link": "https://barcelonacodeschool.com/"
  },
  {
    "slug": "duna-international-college-budapest",
    "name": "Duna International College Budapest",
    "link": "https://www.dunacollege.com/"
  }
];
